
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  FreelancerUmbrellaInvitationsResource,
} from '../models';
import {
    FreelancerUmbrellaInvitationsResourceFromJSON,
    FreelancerUmbrellaInvitationsResourceToJSON,
} from '../models';

export interface GetFreelancerUmbrellaInvitationsRequest {
    freelancerCompanyId: string;
}

/**
 * 
 */
export class FreelancerUmbrellaInvitationsApi extends runtime.BaseAPI {

    /**
     * Fetch all accepted invitations, as well as any pending ones, sent by a freelancer to their umbrella company.
          */
    async getFreelancerUmbrellaInvitationsRaw(requestParameters: GetFreelancerUmbrellaInvitationsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerUmbrellaInvitationsResource>> {
        if (requestParameters['freelancerCompanyId'] == null) {
            throw new runtime.RequiredError(
                'freelancerCompanyId',
                'Required parameter "freelancerCompanyId" was null or undefined when calling getFreelancerUmbrellaInvitations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancerUmbrellaInvitationsResource>({
            path: `/compliance/api/freelancer-company/{freelancerCompanyId}/umbrella-invitations`.replace(`{${"freelancerCompanyId"}}`, encodeURIComponent(String(requestParameters['freelancerCompanyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancerUmbrellaInvitationsResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Fetch all accepted invitations, as well as any pending ones, sent by a freelancer to their umbrella company.
          */
    async getFreelancerUmbrellaInvitations(requestParameters: GetFreelancerUmbrellaInvitationsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerUmbrellaInvitationsResource> {
        const response = await this.getFreelancerUmbrellaInvitationsRaw(requestParameters, initOverrides);
        return response._data;
    }

}
